import * as React from 'react';
import { AncestorIdData, AncestorNameData } from 'modules/domains/foldering';
import { FolderClosed } from 'ui/icons/action/FolderClosed';
import { FolderOpen } from 'ui/icons/action/FolderOpen';
import { ChevronRightSmall } from 'ui/icons/navigation/ChevronRightSmall';
import { Tooltip } from 'ui/tooltip/Tooltip';
import { BreadcrumbName } from './BreadcrumbName';
import { SegmentWrapper } from '../Folders.styles';

type Props = {
  /** the id and name of the breadcrumb */
  data: AncestorIdData & AncestorNameData;
  /** if the folder icon should be hidden */
  hideIcon?: boolean;
  /** if this folder is currently open */
  isCurrentFolder: boolean;
  /** if this is the last breadcrumb in a list */
  isLastCrumb?: boolean;
  /** if this is the tinier display version */
  isMini?: boolean;
  /** if this is the root breadcrum */
  isRoot?: boolean;
  /** optional override for the name, useful for "All" override */
  nameOverride?: string;
  /** the depth from the top level this breadcrumb is  */
  nestIndex: number;
};

export const SimpleBreadcrumb = ({
  data,
  hideIcon = false,
  isCurrentFolder = false,
  isLastCrumb = false,
  isMini = false,
  isRoot = false,
  nameOverride,
  nestIndex,
  ...props
}: Props) => {
  const [showTip, setShowTip] = React.useState(false);

  return (
    <SegmentWrapper data-test="simple-breadcrumb" isRoot={isRoot} {...props}>
      {!isRoot && nestIndex !== 0 && <ChevronRightSmall />}
      {!hideIcon && isCurrentFolder && (
        <FolderOpen height={isMini ? 16 : 24} width={isMini ? 16 : 24} />
      )}
      {!hideIcon && !isCurrentFolder && (
        <FolderClosed height={isMini ? 16 : 24} width={isMini ? 16 : 24} />
      )}

      <Tooltip isEnabled={showTip} tooltipContent={nameOverride || data.name}>
        <BreadcrumbName
          id={data.id}
          isLink={!isCurrentFolder}
          isMini={isMini}
          isLastCrumb={isLastCrumb}
          name={nameOverride || data.name}
          handleOverflow={setShowTip}
        />
      </Tooltip>
    </SegmentWrapper>
  );
};
